import { useQuery } from "@tanstack/react-query";
import { useParams } from "react-router-dom";

import { ENDPOINTS } from "@/api/application-api";
import { useUserToken } from "@/context/auth-context";
import { authHeader } from "@/utils/headers";
import { handleResponse } from "@/utils/errorResponseHandlers";

export const useGetPermissions = () => {
  const { workspaceId } = useParams();
  const userToken = useUserToken();
  return useQuery({
    queryKey: ["permissions", workspaceId],
    queryFn: () =>
      fetch(`${ENDPOINTS.get_user_permissions(Number(workspaceId))}`, {
        headers: authHeader(userToken),
      }).then(handleResponse),
  });
};
